// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__nH21T","inner":"Form_inner__3AG5w","range":"Form_range__1ylQP","name":"Form_name__2ffbN","actions":"Form_actions__qv9aX"};